/**
 * This should hold all the functionality for handling the RaceControl view.
 * For now it only contains if the raceControl is running or not.
 *
 * TODO: All other logic resides in the RaceControl component, and should be moved here.
 */
import { defineStore, storeToRefs } from 'pinia';
import { readonly, ref } from 'vue';

export const useRaceControlStore = defineStore('racecontrolstore', () => {
    // We need to know if the raceControl is running or not
    const isRunning = ref(false);

    return {
        /**
         * Readonly property to determine if the raceControl is running or not
         */
        IsRunning: readonly(isRunning),

        /**
         * A method to enable the raceControl
         */
        Enable: () => (isRunning.value = true),
    };
});

/**
 * A reactive reference to the common store.
 * @returns
 */
export const useRaceControlStoreRef = () => storeToRefs(useRaceControlStore());
